var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowButtonRight = function SvgArrowButtonRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.207 23.751 12.471-10.984a1.066 1.066 0 0 0 0-1.539L7.207.249a.987.987 0 0 0-1.414.107l-1.557 1.85a1.03 1.03 0 0 0 .111 1.438l9.453 8.165a.25.25 0 0 1 0 .379l-9.45 8.168a1.02 1.02 0 0 0-.349.7 1 1 0 0 0 .238.741l1.558 1.851a.99.99 0 0 0 1.414.107Z"
  })));
};
export default SvgArrowButtonRight;